import { Check, Mail, Globe } from "lucide-react";
import { Reveal } from "./Reveal";
import { ContactForm } from "./ContactForm";

const BENEFITS = [
  "Friendly initial conversation",
  "Clear recommendations",
  "No technical knowledge required",
  "No obligation",
];

export const ContactBlock = ({ heading }) => (
  <Reveal>
    <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
      <div className="grid lg:grid-cols-2 gap-12">
        <div>
          <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">LET'S TALK</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF] leading-tight">
            {heading || <>Ready to Get Your <span className="text-gradient">Business Online?</span></>}
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#AEBFD8] leading-relaxed max-w-xl">
            Book a free consultation and tell us what your business needs. We'll explain the next steps clearly
            and recommend a solution that fits your goals.
          </p>

          <ul className="mt-8 space-y-3">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-center gap-3 text-[#F7FAFF] font-medium">
                <span className="grid place-items-center w-6 h-6 rounded-full bg-[rgba(69,224,181,0.15)] border border-[rgba(69,224,181,0.4)] shrink-0">
                  <Check size={14} className="text-[#45E0B5]" />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col gap-3">
            <a href="mailto:team@harmanaisolutions.com" data-testid="contact-email"
              className="inline-flex items-center gap-3 text-[#AEBFD8] hover:text-[#39D5FF] transition">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-[rgba(0,168,255,0.15)] border border-[rgba(65,176,255,0.4)]"><Mail size={16} className="text-[#39D5FF]" /></span>
              team@harmanaisolutions.com
            </a>
            <a href="https://harmanaisolutions.com" data-testid="contact-website"
              className="inline-flex items-center gap-3 text-[#AEBFD8] hover:text-[#39D5FF] transition">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-[rgba(0,168,255,0.15)] border border-[rgba(65,176,255,0.4)]"><Globe size={16} className="text-[#39D5FF]" /></span>
              harmanaisolutions.com
            </a>
          </div>

          <div className="mt-8 hidden md:flex justify-center">
            <img src="/assets/chat.png" alt="" aria-hidden="true" className="w-40 drop-shadow-[0_0_32px_rgba(0,168,255,0.5)]" />
          </div>
        </div>

        <div data-testid="consultation-form-wrap">
          <ContactForm />
        </div>
      </div>
    </div>
  </Reveal>
);
